import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHomeOwnerStart,
  getHomeOwnerSuccess,
  getHomeOwnerFailure,
} from "../reducers/getHomeOwnerReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getHomeOwnerShip = createAsyncThunk(
  "getHomeOwnerShip",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHomeOwnerStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Home/GetOwnership`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHomeOwnerSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHomeOwnerFailure(error.response.data.Message));

      throw error;
    }
  }
);
